import {
    SET_SELECTED_PULLED_ELEMENTS,
    SET_BULK_WINDOW_POSITIONS,
    SET_WINDOW_POSITION} from 'constants/action-types.js';

let initialState = {
    windowPositions: {},
    selectedElements: {},
};

const windowsReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_BULK_WINDOW_POSITIONS:
        return {
            ... state,
            windowPositions: {
                ... state.windowPositions,
                ... action.payload
            }
        };
    case SET_WINDOW_POSITION:
        let windowPositions = state.windowPositions || {};
        windowPositions[action.payload.id] = action.payload.position;
        return {
            ... state,
            windowPositions
        };
    case SET_SELECTED_PULLED_ELEMENTS:
        return {
            ... state,
            selectedElements: action.payload
        };
    default:
        return state;
    }
};

export default windowsReducer;
